module.exports = __webpack_public_path__ + "site/img/288.3bb5df89.jpg";